import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/FreightTemplates/BillOfLading/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__description')}>
          <h2 className={cn('about__heading')}>
            What is a Bill of Lading?
          </h2>
          <p className={cn('about__paragraph')}>
            This essential document, issued by a carrier to a shipper, serves as a 
            cornerstone of global trade by detailing the type, quantity, and destination 
            of goods being transported. Acting as a contract of carriage, a receipt of 
            goods, and a document of title, the B/L ensures a smooth logistics process, 
            confirms the carrier’s receipt of the cargo, and enables the holder to claim 
            the goods upon arrival.
          </p>
          <div className={cn('about__buttons')}>
            <a
              className={cn('about__button-download-word')}
              href='/download/Resources/FreightTemplates/bill_of_lading.docx'
              target='_blank'
            >
              Download (Word)    
            </a>
            <a
              className={cn('about__button-download-pdf')}
              href='/download/Resources/FreightTemplates/bill_of_lading.pdf'
              target='_blank'
            >
              Download (pdf)    
            </a>
          </div>
        </div>

        <div className={cn('about__image-container')}>
          <picture>
            <source
              srcSet="/images/pages/Resources/FreightTemplates/BillOfLading/template@2x.webp 2x, 
                      /images/pages/Resources/FreightTemplates/BillOfLading/template.webp 1x"
              sizes="100vw"
            />
            <img
              className={cn('about__image')}
              src="/images/pages/Resources/FreightTemplates/BillOfLading/template.webp"
              alt="template"
            />
          </picture>
        </div>

      </div>
    </section>
  );
};

export default SectionAbout;